import apollo from '@/graphql'

import CloseDeviceIssueDetails from '@/graphql/device_issue/CloseDeviceIssueDetails.gql'
import DeviceIssueDetailsQuery from '@/graphql/device_issue/DeviceIssueDetailsQuery.gql'
import SaveDeviceIssueDetails from '@/graphql/device_issue/SaveDeviceIssueDetails.gql'
import SaveAssignedRep from '@/graphql/device_issue/SaveAssignedRep.gql'
import SaveDeviceIssueNote from '@/graphql/device_issue_note/SaveDeviceIssueNote.gql'

// initial state
const state = {
  deviceIssueDetails: {},
  editableDeviceIssueFields: {},
  isSavingRep: false,
  deviceIdSelected: null,
}

// getters
const getters = {
  deviceIssueDetails: st => st.deviceIssueDetails,
  editableDeviceIssueFields: st => st.editableDeviceIssueFields,
  isSavingRep: st => st.isSavingRep,
  deviceIdSelected: st => st.deviceIdSelected,
}

// mutations
const mutations = {
  createDeviceIssueDetails() {
    state.editableDeviceIssueFields = {
      devicesId: null,
      subtypesId: null,
      typesId: null,
      assignedRep: null,
    }
  },

  setDeviceIssueDetails(st, deviceIssueDetails) {
    state.deviceIssueDetails = deviceIssueDetails
  },

  setEditableDeviceIssueFields(st, deviceIssueDetails) {
    state.editableDeviceIssueFields = {
      devicesId: deviceIssueDetails.devicesId,
      id: +(deviceIssueDetails.id),
      subtypesId: deviceIssueDetails.subtype.id,
      typesId: deviceIssueDetails.subtype.typesId,
    }
  },

  setIsSavingRep(state, isSavingRep) {
    state.isSavingRep = isSavingRep
  },

  setDeviceIdSelected(state, deviceIdSelected) {
    state.deviceIdSelected = deviceIdSelected
  },
}

// actions
const actions = {
  closeDeviceIssueDetails(context, { $message, $router }) {
    apollo.defaultClient
      .mutate({
        mutation: CloseDeviceIssueDetails,
        variables: { fields: state.editableDeviceIssueFields },
        refetchQueries: [state.deviceIssueDetails.id].filter(id => id).map(id => ({
          query: DeviceIssueDetailsQuery,
          variables: { id: +id },
        })),
      })
      .then(({ data: { closeDeviceIssueDetails: { id } } }) => {
        $message({
          message: 'Issue Closed',
          type: 'success',
        })
        $router.push(`/device-issue/${id}`)
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
  },

  loadDeviceIssueDetails({ commit }, { id }) {
    apollo.defaultClient
      .watchQuery({
        fetchPolicy: 'network-only',
        pollInterval: 5000,
        query: DeviceIssueDetailsQuery,
        variables: { id: +id },
      })
      .subscribe(({ data: { deviceIssueDetails } }) => {
        commit('setDeviceIssueDetails', deviceIssueDetails)
        commit('setEditableDeviceIssueFields', deviceIssueDetails)
      })
  },

  saveDeviceIssueDetails(context, { $message, $router, editMode }) {
    apollo.defaultClient
      .mutate({
        mutation: SaveDeviceIssueDetails,
        variables: {
          fields: {
            ...state.editableDeviceIssueFields,
            devicesId: +state.editableDeviceIssueFields.devicesId,
          },
        },
        refetchQueries: [state.deviceIssueDetails.id].filter(id => id).map(id => ({
          query: DeviceIssueDetailsQuery,
          variables: { id },
        })),
      })
      .then(({ data: { saveDeviceIssueDetails: { id } } }) => {
        $message({
          message: 'Changes Saved',
          type: 'success',
        })

        $router.push(`/device-issue/${id}${editMode ? '?isEdit=true' : ''}`)
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
  },

  saveAssignedRep(context, { $message, issues }) {
    this.commit('setIsSavingRep', true)
    let itemsProcessed = 0
    return Promise.all(issues.map(issue => apollo.defaultClient
      .mutate({
        mutation: SaveAssignedRep,
        variables: { fields: { id: issue.id, assignedRep: issue.assignedRep } },
      })
      .then(() => {
        $message({
          message: 'Changes Saved',
          type: 'success',
        })
        itemsProcessed += 1
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
        itemsProcessed += 1
      })
      .then(() => {
        if (itemsProcessed === issues.length) {
          this.commit('setIsSavingRep', false)
        }
      })))
  },

  saveDeviceIssueNote(context, { $message, note }) {
    return apollo.defaultClient
      .mutate({
        mutation: SaveDeviceIssueNote,
        variables: { fields: note },
        refetchQueries: [state.deviceIssueDetails.id].filter(id => id).map(id => ({
          query: DeviceIssueDetailsQuery,
          variables: { id },
        })),
      })
      .then(() => {
        $message({
          message: 'Issue Note Saved',
          type: 'success',
        })
      })
      .catch((err) => {
        $message({
          message: err,
          type: 'error',
        })
      })
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/device_issue/DeviceIssueDetails.js